import styled from "styled-components";

export const CreateWorkflowViewerConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;
export const HeaderTitle = styled.div`
  color: #0a85c7;
  font-size: 1.5rem;
  font-weight: 600;
`;
export const HeaderSubtitle = styled.div`
  font-weight: 300;
  font-size: 1rem;
  color: #0a85c7;
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Title = styled.div`
  font-size: 1.75rem;
  color: #0a85c7;
  font-weight: 400;
  margin-top: 3rem;
`;
export const InformationBoxContainer = styled.div`
  background-color: #e7f3f9;
  padding: 10px 1rem;
  border-radius: 0.25rem;
  width: 932px;
  height: 116px;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 1rem;
  margin: 3rem 0px;
`;
export const InfoTitle = styled.div`
  color: #02273c;
  font-size: 1.25rem;
`;
export const InfoContent = styled.div`
  font-size: 1rem;
  font-weight: 400;
`;
export const Bold = styled.div`
  font-weight: 700;
`;
export const ButtonContainer = styled.div`
  display: flex;
  column-gap: 0.5rem;
`;
